import React from 'react';
import { motion } from 'framer-motion';

function Home() {
  const team = [
    {
      nombre: "Azucena Maribel Maya Carrillo",
      rol: "Directora",
      descripcion: "Relacionamiento de resultados con el desarrollo nacional y modelo predictivo de vigilancia tecnológica",
      institucion: "ESPE"
    },
    {
      nombre: "Juan Marcelo Ibujés Villacís",
      rol: "Codirector",
      descripcion: "Vigilancia tecnológica, levantamiento y análisis de datos",
      institucion: "EPN"
    },
    {
      nombre: "Ángel Marcelo Rea Guamán",
      rol: "Investigador",
      descripcion: "Desarrollo de herramientas tecnológicas y de IA",
      institucion: "ESPE"
    },
    {
      nombre: "Ana Verónica Guamán Novillo",
      rol: "Investigadora",
      descripcion: "TICs, integración de IA, análisis de resultados",
      institucion: "ESPE"
    },
    {
      nombre: "Sandra Patricia Galarza Torres",
      rol: "Investigadora",
      descripcion: "Estado del arte, diseño de instrumentos, análisis e interpretación",
      institucion: "ESPE"
    },
    {
      nombre: "Mishell Romina Angulo Álvarez",
      rol: "Investigadora",
      descripcion: "Análisis e interpretación de datos",
      institucion: "ESPE"
    },
    {
      nombre: "Jennifer Katherin Célleri Pacheco",
      rol: "Investigadora",
      descripcion: "Desarrollo tecnológico",
      institucion: "UTMachala"
    },
    {
      nombre: "Raquel Miroslava Tinoco Egas",
      rol: "Investigadora",
      descripcion: "Revisión de literatura, análisis e interpretación de resultados",
      institucion: "UTMachala"
    },
    {
      nombre: "Jaime Rodrigo Moreno Vallejo",
      rol: "Investigador",
      descripcion: "Gestor de investigación",
      institucion: "UPEC"
    },
    {
      nombre: "Willington Gerardo Mera Rodríguez",
      rol: "Investigador",
      descripcion: "Análisis de literatura e interpretación de datos",
      institucion: "UPEC"
    }
  ];

  const objetivos = [
    {
      numero: "01",
      icono: "map",
      titulo: "Mapeo",
      descripcion: "Mapear los campos de conocimiento, líneas, grupos y proyectos de investigación de al menos el 30% de las universidades públicas del Ecuador, generados en los últimos cinco años."
    },
    {
      numero: "02",
      icono: "radar",
      titulo: "Vigilancia Tecnológica",
      descripcion: "Determinar el grado actual de uso de la vigilancia tecnológica en al menos el 30% de las universidades públicas para identificar tendencias en I+D."
    },
    {
      numero: "03",
      icono: "analytics",
      titulo: "Análisis Científico",
      descripcion: "Analizar la producción científica de al menos el 50% de los investigadores del 30% de las universidades, con indicadores temáticos, de impacto y perspectiva de género."
    },
    {
      numero: "04",
      icono: "psychology",
      titulo: "IA y ODS",
      descripcion: "Aplicar algoritmos de IA para generar insights automáticos sobre la alineación de la investigación con los ODS y el Plan Nacional de Desarrollo."
    }
  ];

  const features = [
    {
      icono: "explore",
      titulo: "Mapeo del Conocimiento",
      descripcion: "Visualiza en tiempo real las líneas, grupos y proyectos de investigación. Identifica fortalezas institucionales, brechas temáticas y oportunidades de colaboración mediante algoritmos de clustering."
    },
    {
      icono: "sensors",
      titulo: "Vigilancia Tecnológica",
      descripcion: "Monitorea tendencias emergentes en ciencia y tecnología a nivel global. Permite anticiparse a cambios, identificar tecnologías clave y priorizar proyectos alineados a problemáticas sociales y productivas."
    },
    {
      icono: "dashboard",
      titulo: "Dashboards Interactivos",
      descripcion: "Presenta la producción científica a través de visualizaciones dinámicas con indicadores de impacto, redes de colaboración y análisis temático. Incluye perspectiva de género en todos los indicadores."
    },
    {
      icono: "smart_toy",
      titulo: "Inteligencia Artificial",
      descripcion: "Genera insights automáticos sobre la alineación de la investigación con los ODS y el Plan Nacional de Desarrollo. Usa procesamiento de lenguaje natural, análisis semántico y aprendizaje automático."
    }
  ];

  const getInitials = (nombre) => {
    return nombre.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
  };

  const getAvatarColor = (index) => {
    const colors = [
      'from-blue-500 to-cyan-500',
      'from-green-500 to-teal-500',
      'from-purple-500 to-pink-500',
      'from-orange-500 to-red-500',
      'from-indigo-500 to-blue-500',
      'from-pink-500 to-rose-500'
    ];
    return colors[index % colors.length];
  };

  return (
    <>
      {/* Header */}
      <motion.header 
        className="bg-surface-light dark:bg-surface-dark shadow-sm border-b border-border-light dark:border-border-dark z-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="max-w-1xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div>
              <h2 className="text-xl font-bold leading-7 text-slate-900 dark:text-white sm:truncate">
                SIGC — Sistema Inteligente de Gestión del Conocimiento
              </h2>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                Plataforma de inteligencia científica para universidades públicas ecuatorianas
              </p>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 space-y-8">
          
          {/* Hero Section */}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1 }}
            className="glass-panel rounded-2xl p-8 md:p-12 border border-white/20 dark:border-slate-700 mb-8 bg-gradient-to-br from-primary/5 to-purple-500/5 dark:from-primary/10 dark:to-purple-500/10"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="material-icons-round text-white text-3xl">hub</span>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
                  ¿Qué es SIGC?
                </h2>
                <p className="text-slate-600 dark:text-slate-400">
                  Transformando la investigación científica en Ecuador
                </p>
              </div>
            </div>
            
            <p className="text-lg text-slate-700 dark:text-slate-300 leading-relaxed mb-6">
              SIGC es una plataforma inteligente que integra, analiza y visualiza la producción científica 
              de las universidades públicas del Ecuador. Combina inteligencia artificial, minería de datos 
              y vigilancia tecnológica para transformar la información académica dispersa en conocimiento 
              estratégico accionable.
            </p>

            <p className="text-base text-slate-700 dark:text-slate-300 leading-relaxed mb-6">
              La plataforma responde a una necesidad crítica: a pesar del crecimiento sostenido en 
              publicaciones científicas, las universidades ecuatorianas enfrentan barreras significativas 
              para conectar su investigación con los sectores productivos, las políticas públicas y los 
              Objetivos de Desarrollo Sostenible (ODS).
            </p>
            
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2 px-4 py-2 bg-white/50 dark:bg-slate-800/50 rounded-lg">
                <span className="material-icons-round text-primary">verified</span>
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                  Plataforma Oficial CEDIA
                </span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-white/50 dark:bg-slate-800/50 rounded-lg">
                <span className="material-icons-round text-green-500">security</span>
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                  Datos Seguros y Confiables
                </span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-white/50 dark:bg-slate-800/50 rounded-lg">
                <span className="material-icons-round text-purple-500">auto_awesome</span>
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                  Análisis con IA
                </span>
              </div>
            </div>
          </motion.section>

          {/* Features Section */}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="mb-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="material-icons-round text-primary text-3xl">star</span>
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white">
                ¿Qué hace la plataforma?
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                  whileHover={{ scale: 1.02 }}
                  className="glass-panel rounded-xl p-6 border border-white/20 dark:border-slate-700 hover:border-primary/30 transition-all"
                >
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <span className="material-icons-round text-primary text-2xl">
                      {feature.icono}
                    </span>
                  </div>
                  <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-2">
                    {feature.titulo}
                  </h4>
                  <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                    {feature.descripcion}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Universities Carousel Section */}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.35 }}
            className="mb-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="material-icons-round text-primary text-3xl">account_balance</span>
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white">
                Instituciones Participantes
              </h3>
            </div>
            
            <div className="glass-panel rounded-2xl p-8 border border-white/20 dark:border-slate-700 overflow-hidden">
              
              {/* Carousel Container */}
              <div className="relative">
                <div className="overflow-hidden">
                  <motion.div
                    className="flex gap-6"
                    animate={{
                      x: [0, -2400],
                    }}
                    transition={{
                      x: {
                        repeat: Infinity,
                        repeatType: "loop",
                        duration: 30,
                        ease: "linear",
                      },
                    }}
                    style={{ width: "fit-content" }}
                  >
                    {/* First set of universities */}
                    {[
                      { sigla: "ESPOL", nombre: "Escuela Superior Politécnica del Litoral", imagen: "/images/espol.webp" },
                      { sigla: "ESPE", nombre: "Universidad de las Fuerzas Armadas", imagen: "/images/espe.webp" },
                      { sigla: "EPN", nombre: "Escuela Politécnica Nacional", imagen: "/images/epn.webp" },
                      { sigla: "ESPOCH", nombre: "Escuela Superior Politécnica de Chimborazo", imagen: "/images/ESPOCH.webp" },
                      { sigla: "UG", nombre: "Universidad de Guayaquil", imagen: "/images/ug.webp" },
                      { sigla: "YACHAY", nombre: "Universidad de Investigación de Tecnología Experimental Yachay", imagen: "/images/yachay.webp" },
                      { sigla: "UTA", nombre: "Universidad Técnica de Ambato", imagen: "/images/UTA.webp" },
                      { sigla: "UCUENCA", nombre: "Universidad de Cuenca", imagen: "/images/UCUENCA.webp" },
                      { sigla: "UCE", nombre: "Universidad Central del Ecuador", imagen: "/images/UCE.webp" },
                      { sigla: "UTM", nombre: "Universidad Técnica de Manabí", imagen: "/images/UTM.webp" },
                      { sigla: "UPEC", nombre: "Universidad Politécnica Estatal del Carchi", imagen: "/images/upec.webp" },
                      { sigla: "UTMACH", nombre: "Universidad Técnica de Machala", imagen: "/images/utmach.webp" },
                    ].concat([
                      // Duplicate set for seamless loop
                      { sigla: "ESPOL", nombre: "Escuela Superior Politécnica del Litoral", imagen: "/images/espol.webp" },
                      { sigla: "ESPE", nombre: "Universidad de las Fuerzas Armadas", imagen: "/images/espe.webp" },
                      { sigla: "EPN", nombre: "Escuela Politécnica Nacional", imagen: "/images/epn.webp" },
                      { sigla: "ESPOCH", nombre: "Escuela Superior Politécnica de Chimborazo", imagen: "/images/ESPOCH.webp" },
                      { sigla: "UG", nombre: "Universidad de Guayaquil", imagen: "/images/ug.webp" },
                      { sigla: "YACHAY", nombre: "Universidad de Investigación de Tecnología Experimental Yachay", imagen: "/images/yachay.webp" },
                      { sigla: "UTA", nombre: "Universidad Técnica de Ambato", imagen: "/images/UTA.webp" },
                      { sigla: "UCUENCA", nombre: "Universidad de Cuenca", imagen: "/images/UCUENCA.webp" },
                      { sigla: "UCE", nombre: "Universidad Central del Ecuador", imagen: "/images/UCE.webp" },
                      { sigla: "UTM", nombre: "Universidad Técnica de Manabí", imagen: "/images/UTM.webp" },
                      { sigla: "UPEC", nombre: "Universidad Politécnica Estatal del Carchi", imagen: "/images/upec.webp" },
                      { sigla: "UTMACH", nombre: "Universidad Técnica de Machala", imagen: "/images/utmach.webp" },
                    ]).map((uni, index) => (
                      <motion.div
                        key={`uni-${index}`}
                        className="flex-shrink-0 group"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2 }}
                      >
                        <div className="w-40 h-40 bg-white dark:bg-slate-800 rounded-2xl shadow-lg border-2 border-slate-200 dark:border-slate-700 flex flex-col items-center justify-center p-4 group-hover:shadow-xl transition-shadow">
                          {/* Logo real de la universidad */}
                          <div className="w-28 h-28 rounded-xl flex items-center justify-center mb-2 overflow-hidden">
                            <img 
                              src={uni.imagen} 
                              alt={`Logo ${uni.sigla}`}
                              className="w-full h-full object-contain"
                              loading="lazy"
                            />
                          </div>
                          {/* University name */}
                          <div className="text-center">
                            <p className="text-xs font-bold text-slate-900 dark:text-white mb-1">{uni.sigla}</p>
                            <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight line-clamp-2">
                              {uni.nombre}
                            </p>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </motion.div>
                </div>
                
                {/* Gradient overlays for smooth edges */}
                <div className="absolute top-0 left-0 w-20 h-full bg-gradient-to-r from-white dark:from-slate-800 to-transparent pointer-events-none"></div>
                <div className="absolute top-0 right-0 w-20 h-full bg-gradient-to-l from-white dark:from-slate-800 to-transparent pointer-events-none"></div>
              </div>
            </div>
          </motion.section>

          {/* Objetivos Section */}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mb-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="material-icons-round text-primary text-3xl">flag</span>
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white">
                Objetivos Específicos
              </h3>
            </div>
            
            <div className="space-y-4">
              {objetivos.map((objetivo, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.5 + index * 0.1 }}
                  whileHover={{ scale: 1.01 }}
                  className="glass-panel rounded-xl p-6 border border-white/20 dark:border-slate-700 hover:border-primary/30 transition-all flex gap-4"
                >
                  <div className="text-4xl font-bold text-primary/20 min-w-[60px]">
                    {objetivo.numero}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="material-icons-round text-primary">{objetivo.icono}</span>
                      <h4 className="text-lg font-bold text-slate-900 dark:text-white">
                        {objetivo.titulo}
                      </h4>
                    </div>
                    <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                      {objetivo.descripcion}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Team Section */}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.0 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="material-icons-round text-primary text-3xl">group</span>
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white">
                Equipo de Investigación
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
              {team.map((member, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 1.1 + index * 0.05 }}
                  whileHover={{ scale: 1.02, y: -5 }}
                  className="glass-panel rounded-xl p-6 border border-white/20 dark:border-slate-700 hover:border-primary/30 transition-all"
                >
                  <div className="flex items-start gap-4">
                    <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${getAvatarColor(index)} flex items-center justify-center text-white text-xl font-bold shadow-lg flex-shrink-0`}>
                      {getInitials(member.nombre)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-base font-bold text-slate-900 dark:text-white mb-1">
                        {member.nombre}
                      </h4>
                      <p className="text-sm font-medium text-primary mb-2">
                        {member.rol}
                      </p>
                      <p className="text-xs text-slate-600 dark:text-slate-400 mb-2 leading-relaxed">
                        {member.descripcion}
                      </p>
                      <div className="flex items-center gap-2 text-xs text-slate-600 dark:text-slate-400">
                        <span className="material-icons-round text-sm">school</span>
                        <span>{member.institucion}</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Footer Section */}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2 }}
            className="mt-8 glass-panel rounded-2xl p-8 border border-white/20 dark:border-slate-700 bg-gradient-to-br from-primary/5 to-purple-500/5 dark:from-primary/10 dark:to-purple-500/10 text-center"
          >
            <p className="text-lg font-bold text-slate-900 dark:text-white mb-2">
              Proyecto financiado por los Fondos I+D+i de CEDIA
            </p>
            <p className="text-base text-slate-600 dark:text-slate-400">
              Corporación Ecuatoriana para el Desarrollo de la Investigación y la Academia
            </p>
          </motion.section>
      </div>
    </>
  );
}

export default Home;
